// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ImageTokens } from './type';

const imageTokens: ImageTokens = {
  imageSpinColor: 'Neutral-text-2',
  imageCircleBorderRadius: 'Radius-50%',
  imageCircleBorderColor: 'Neutral-border-1',
  imageRoundedBorderRadius: 'Radius-4',
  imageRoundedBorderColor: 'Neutral-border-1',
  imageThumbnailBorderRadius: 'Radius-4',
  imageThumbnailBorderColor: 'Neutral-border-1',
  imagePlaceholderBackgroundColor: 'Neutral-fill-2',
  imageErrorBackgroundColor: 'Neutral-fill-2',
  imageErrorFontColor: 'Neutral-text-4',
  imageErrorFontSize: '12/regular',
  imageGroupNearlyMargin: 'Margin-8',
  imageMaskBackgroundColor: 'Mask-fill-1',
  imageBackgroundColor: 'Neutral-fill-2',
};

export default imageTokens;
